import Accordion from "react-bootstrap/Accordion";
import faqsBuyer from "../utils/faqs-buyer.json";
import faqsSeller from "../utils/faqs-seller.json";
import { DASHBOARD_TYPE } from "../utils/enums";

interface InputProps {
  type: "buyer" | "seller";
  keyword?: string;
}

const Faqs: React.FC<InputProps> = ({ type, keyword = "" }) => {
  let faqData = type === DASHBOARD_TYPE.BUYER ? faqsBuyer : faqsSeller;
  if (keyword?.length > 0) {
    faqData = faqData?.filter((k: any) =>
      k?.question?.toLowerCase().includes(keyword.toLowerCase())
    );
  }

  return (
    <Accordion className="faqAccordion" defaultActiveKey="0">
      {faqData?.length === 0 && <div>No question found.</div>}
      {faqData.map((faq, index) => (
        <Accordion.Item
          className="mb-3"
          eventKey={index.toString()}
          key={index}
        >
          <Accordion.Header style={{ marginTop: 0 }}>
            {faq?.question}
          </Accordion.Header>
          <Accordion.Body>{faq?.answer}</Accordion.Body>
        </Accordion.Item>
      ))}
    </Accordion>
  );
};

export default Faqs;
